import {Icon} from '@ezcater/tapas';
import {faLocationArrow, faSpinnerThird} from '@fortawesome/pro-regular-svg-icons';
import useTranslation from 'next-translate/useTranslation';
import {twMerge} from 'tailwind-merge';

type CurrentLocationRowProps = {
  id: string;
  isActive?: boolean;
  isLoading?: boolean;
  onClick: () => void;
};

const CurrentLocationRow: React.FC<CurrentLocationRowProps> = ({
  id,
  isActive = false,
  isLoading = false,
  onClick,
}) => {
  const {t} = useTranslation('app-bar');

  return (
    <button
      aria-selected={isActive}
      className={twMerge(
        'flex w-full cursor-pointer items-center gap-3 rounded-lg px-2 py-2 hover:bg-peppercorn-50',
        isActive && 'bg-peppercorn-50',
      )}
      data-testid="where-use-current-location"
      id={id}
      onClick={onClick}
      onMouseDown={event => event.preventDefault()}
      role="option"
      tabIndex={-1}
      type="button"
    >
      <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-blueberry-50 text-blueberry-400">
        <Icon
          aria-hidden
          className={isLoading ? 'animate-spin' : undefined}
          icon={isLoading ? faSpinnerThird : faLocationArrow}
          size="small"
        />
      </span>
      <span className="min-w-0 overflow-hidden text-left">
        <span className="block text-sm font-semibold text-peppercorn-800">
          {t('eventBarV2.where.useCurrentLocation.label')}
        </span>
        <span className="block text-sm text-peppercorn-500">
          {t('eventBarV2.where.useCurrentLocation.subtitle')}
        </span>
      </span>
    </button>
  );
};

export default CurrentLocationRow;
